export const generateGetSubtasksQueryVariables = (sourceAri: string, itemIds: string[]) => ({
	sourceAri,
	itemIds,
});
